module.exports = __webpack_public_path__ + "img/switzerland.291460d3.svg";